"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { IMAGE_FILE_TYPES } from "@/libs/builder/consts";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

const tileLength = 3;
export const tileInputs = [
  {
    name: "title",
    type: "string",
    required: true,
    defaultValue: "Title",
  },
  {
    name: "href",
    type: "string",
    required: true,
    defaultValue: "/",
  },
  {
    name: "ctaText",
    type: "string",
    required: true,
    defaultValue: "Click me",
  },
  {
    name: "content",
    friendlyName: "Tile items",
    type: "list",
    required: true,
    defaultValue: [
      {
        title: "See How Smooth It Feels",
        text: "Aura is elegant and light, beautifully balanced, with a silky satin finish and a natural shape that's a pleasure to hold. We've fused exceptional materials with cutting-edge design to craft a compact, singular device that's easier to handle and carry.",
        img: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2Fa9ff7d81326a40cba59334078ce44085",
      },
      {
        title: "Stay in the Moment",
        text: "There's no hurry with Ploom Aura. Its smart HeatFlow technology is designed to deliver a perfectly timed ritual at the optimal temperature for true tobacco taste and consistent pleasure from the first puff to the last.  Enjoy consistent sensory satisfaction with five minutes of unlimited puffs. Or use our handy [NAME] app to tailor your session length and intensity to personalize your experience.",
        img: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2Fa9ff7d81326a40cba59334078ce44085",
      },
      {
        title: "Don't Rush the Ritual",
        text: "No fire, smoke, or ash make Aura a better fit for more social occasions. No more filling up spaces with the smell of smoke and no more hunting for an ashtray. Ploom only leaves behind a pleasant aroma, so you can simply enjoy your ritual while still spending time with the people that matter most. ",
        img: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2Fa9ff7d81326a40cba59334078ce44085",
      },
    ],
    subFields: [
      {
        name: "title",
        type: "string",
      },
      {
        name: "text",
        type: "string",
      },
      {
        name: "img",
        friendlyName: "Tile image",
        type: "file",
        allowedFileTypes: IMAGE_FILE_TYPES,
        defaultValue:
          "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F0e1d6bb8acf545c5a63ec12d1b015a41",
      },
    ],
    onChange: (options: Map<string, unknown>) => {
      const items = options.get("content");
      if (Array.isArray(items) && items.length > tileLength) {
        options.set("content", items.slice(0, tileLength));
        alert("You can add maximum 3 items");
      }
    },
  },
] as const satisfies Inputs;

export const TileComponent: RegisteredComponent = {
  name: "TileComponent",
  component: dynamic(async () =>
    withValidation(tileInputs, (await import("./Tile")).Tile, "Tile")
  ),
  inputs: tileInputs,
};
